import { FormControlLabel as MuiFormControlLabel, styled, Switch as MuiSwitch } from '@mui/material';

export const FormControlLabel = styled(MuiFormControlLabel)(() => ({
  marginLeft: '0 !important',
}));

export const CustomSwitch = styled(MuiSwitch)(({ theme }) => ({
  width: 42,
  height: 26,
  padding: 0,
  borderRadius: 13,
  outline: `1px solid ${theme.palette.secondary.main}`,
  '& .MuiSwitch-switchBase': {
    padding: 0,
    margin: 2,
    '&.Mui-checked': {
      transform: 'translateX(16px)',
      '& + .MuiSwitch-track': {
        backgroundColor: theme.palette.primary.main,
        opacity: 1,
      },
      '& .MuiSwitch-thumb': {
        backgroundColor: '#fff',
      },
    },
    '&.Mui-disabled': {
      '&.Mui-checked': {
        '& + .MuiSwitch-track': {
          opacity: 0.4,
        },
      },
    },
  },
  '&:has(.Mui-checked)': {
    outline: `1px solid transparent`,
  },
  '&:has(.Mui-disabled)': {
    opacity: 0.7,
  },
  '& .MuiSwitch-thumb': {
    width: 22,
    height: 22,
    backgroundColor: theme.palette.secondary.main,
    boxShadow: 'none',
  },
  '& .MuiSwitch-track': {
    borderRadius: 13,
    backgroundColor: 'transparent',
    opacity: 1,
    '&::before, &::after': {
      content: '""',
      position: 'absolute',
      top: '50%',
      transform: 'translateY(-50%)',
      width: 16,
      height: 16,
    },
    '&::before': {
      backgroundImage: `url('data:image/svg+xml;utf8,<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="${encodeURIComponent(
        '#fff'
      )}" viewBox="0 0 16 16"><path d="M10.97 4.97a.75.75 0 0 1 1.07 1.05l-3.99 4.99a.75.75 0 0 1-1.08.02L4.324 8.384a.75.75 0 1 1 1.06-1.06l2.094 2.093 3.473-4.425z"/></svg>')`,
      left: 4,
    },
    '&::after': {
      backgroundImage: `url('data:image/svg+xml;utf8,<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="${encodeURIComponent(
        theme.palette.secondary.main
      )}" viewBox="0 0 16 16"><path d="M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708"/></svg>')`,
      right: 4,
    },
  },
}));
